"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var RuleConstants_1 = require("../../definitions/constants/RuleConstants");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

var ValueInput =
/** @class */
function (_super) {
  __extends(ValueInput, _super);

  function ValueInput(props, state) {
    var _this = _super.call(this, props, state) || this;

    var value = _this.props.value;
    _this.state = {
      valueToValidate: value
    };
    return _this;
  }

  ValueInput.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        scale = _a.scale,
        value = _a.value;
    var _b = this.state,
        valueToValidate = _b.valueToValidate,
        invalidValue = _b.invalidValue;
    var currentValue = invalidValue ? invalidValue : value;
    var isPercentageScale = scale === RuleConstants_1.RULE_SCALES.PERCENTAGE;
    var scaleClass = isPercentageScale ? 'is-percentage' : 'is-numeric';
    return react_1.default.createElement(ca_ui_toolkit_1.TextInput, {
      className: scaleClass,
      style: {
        backgroundColor: 'white'
      },
      placeholder: '',
      value: currentValue,
      validationErrorText: this._getValidatitionaErrorText(valueToValidate),
      hasValidationError: !this._isValidInput(valueToValidate),
      onBlur: this._onBlur.bind(this),
      onValueChange: function onValueChange(valueToValidate) {
        return _this.setState({
          valueToValidate: valueToValidate
        });
      },
      onValueAccept: function onValueAccept(valueToAccept) {
        var message = _this._getValidatitionaErrorText(valueToAccept);

        if (message) {
          // invalid value
          _this.setState({
            valueToValidate: undefined,
            invalidValue: valueToAccept
          });
        } else {
          var value_1 = _this.props.value;

          if (valueToAccept !== value_1) {
            _this._saveEnteredValueToContentModelValue(valueToAccept);
          }
        }
      }
    });
  };

  ValueInput.prototype._onBlur = function (event) {
    var value = this.props.value;
    var enteredValue = event['target'].value;

    if (enteredValue !== value) {
      var isValid = this._isValidInput(enteredValue);

      if (isValid) {
        this._saveEnteredValueToContentModelValue(enteredValue);
      } else {
        // The value entered when lost focus is invalid so set the valueToValidate back to original value
        // This is needed to clear the error state in Toolkit TextInput
        this.setState({
          valueToValidate: value,
          invalidValue: undefined
        });
      }
    }
  };

  ValueInput.prototype._saveEnteredValueToContentModelValue = function (enteredValue) {
    var _a = this.props,
        valueOnChange = _a.valueOnChange,
        uiContext = _a.uiContext;
    this.setState({
      invalidValue: undefined
    });
    var newNumValue = uiContext.getNumberFromFormattedValue(enteredValue);
    valueOnChange(newNumValue);
  };

  ValueInput.prototype._isValidInput = function (value) {
    var uiContext = this.props.uiContext;
    var invalidInput = true;

    if (value && value.length) {
      var newNumValue = uiContext.getNumberFromFormattedValue(value);
      invalidInput = isNaN(newNumValue) || this._isInvalidType(newNumValue);
    }

    return !invalidInput;
  };

  ValueInput.prototype._getValidatitionaErrorText = function (value) {
    var type = this.props.type;

    if (!this._isValidInput(value)) {
      if (type === RuleConstants_1.CONDITION_TYPES.IT || type === RuleConstants_1.CONDITION_TYPES.IB) {
        return StringResources_1.default.get('conditionalFormattingInvalidRuleConditionValueForTopAndBottom');
      }

      return StringResources_1.default.get('conditionalFormattingInvalidRuleConditionValue');
    }

    return null;
  };

  ValueInput.prototype._isInvalidType = function (value) {
    var type = this.props.type;
    var inValid = false;

    if (type === RuleConstants_1.CONDITION_TYPES.IT || type === RuleConstants_1.CONDITION_TYPES.IB) {
      if (!(value >= 0 && value <= 100)) {
        inValid = true;
      }
    }

    return inValid;
  };

  return ValueInput;
}(react_1.Component);

exports.default = mobx_react_1.observer(ValueInput);
